module.exports = __webpack_public_path__ + "static/media/ico_message.5b337d5c.png";